export enum ReportVisibility {
    Shared = 'Shared',
    Public = 'Public',
    Private = 'Private',
}